import React, { useEffect, useState } from "react";
import { ImageTextCollage as ImageTextCollageType } from "../../../sanity/lib/types/imageTextCollage";

import { stegaClean } from "@sanity/client/stega";
import { useAppContext } from "../../provider/AppProvider";
import { ImageElement } from "../Image";

type Props = ImageTextCollageType;

export const ImageTextCollage = (props: Props) => {
    const cleanedTitle = stegaClean(props.slides);
    const { setCursorState, setCursorText } = useAppContext();

    const [activeSlide, setActiveSlide] = useState<number>(0);

    useEffect(() => {
        setCursorText(cleanedTitle[0].tapText || "Tap to change slide");
    }, []);

    const setSlide = () => {
        const newActiveSlide = activeSlide === cleanedTitle.length - 1 ? 0 : activeSlide + 1;
        setActiveSlide(newActiveSlide);
        setCursorText(cleanedTitle[newActiveSlide].tapText || "Tap to change slide");
    };

    return (
        <section
            className="container relative image-text-collage py-14"
            onMouseEnter={() => setCursorState("click")}
            onMouseLeave={() => setCursorState("default")}
        >
            <div className="mx-2.5 md:mx-5">
                {cleanedTitle.map((slide, index) => (
                    <div
                        key={index}
                        onClick={() => {
                            setSlide();
                        }}
                        className={`grid grid-cols-12 slide md:aspect-[1440/900] md:max-h-dvh absolute top-0 left-0 w-full ${index === activeSlide ? "relative opacity-100" : "opacity-0"} `}
                    >
                        <div className="hidden md:block images col-span-12 w-full aspect-[1440/676] absolute top-0">
                            {slide.images?.map((image, imgIndex) => (
                                <React.Fragment key={imgIndex}>
                                    {image.image?.image && (
                                        <ImageElement
                                            key={index + " " + imgIndex}
                                            width={600}
                                            src={image.image.image}
                                            alt={image.image.alt || ""}
                                            className={`absolute image top-[${image.position}] w-[27%] left-0 h-auto object-cover ${image.format === "portrait" ? "aspect-[4/5]" : "aspect-[5/4]"}`}
                                        />
                                    )}
                                </React.Fragment>
                            ))}
                        </div>

                        <div className="block md:hidden images col-span-12 w-full aspect-[355/439] relative">
                            {slide.mobileImages?.map((image, imgIndex) => (
                                <React.Fragment key={imgIndex}>
                                    {image.image?.image && (
                                        <ImageElement
                                            key={index + " " + imgIndex}
                                            width={600}
                                            src={image.image.image}
                                            alt={image.image.alt || ""}
                                            className={`absolute image-mobile w-[52%] h-auto object-cover aspect-[3/4]`}
                                        />
                                    )}
                                </React.Fragment>
                            ))}
                        </div>

                        <p className="col-span-12 mt-6 mb-6 text-right md:hidden m-body-m">
                            {slide.tapText || "Tap to change slide"}
                        </p>

                        <h2 className="z-10 flex flex-col col-span-12 m-display-2 md:d-display-1 md:mt-auto">
                            <span key={"word- and"}>and</span>
                            {slide.slideTitle.split("and ").map((word, idx) => (
                                <span key={"word- " + idx}>{word}</span>
                            ))}
                        </h2>
                    </div>
                ))}
            </div>
        </section>
    );
};
